var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStripeIconSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2C0 0.895431 0.895431 0 2 0H30C31.1046 0 32 0.895431 32 2V30C32 31.1046 31.1046 32 30 32H2C0.895431 32 0 31.1046 0 30V2Z",
    fill: "#635BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7474 12.4392C14.7474 11.6872 15.3634 11.3912 16.3874 11.3912C17.8594 11.3912 19.7154 11.8392 21.1874 12.6312V8.08722C19.5794 7.44722 17.9954 7.19922 16.3954 7.19922C12.4674 7.19922 9.85938 9.24722 9.85938 12.6712C9.85938 18.0072 17.2114 17.1592 17.2114 19.4632C17.2114 20.3512 16.4354 20.6392 15.3554 20.6392C13.7474 20.6392 11.6994 19.9832 10.0754 19.0952V23.6952C11.8754 24.4712 13.6914 24.7992 15.3554 24.7992C19.3794 24.7992 22.1474 22.8072 22.1474 19.3432C22.1154 13.5832 14.7474 14.6072 14.7474 12.4392Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripeIconSquare);
export default __webpack_public_path__ + "static/media/Stripe_icon-square.7d82b13e93cdae86cf4701ae28eb9b50.svg";
export { ForwardRef as ReactComponent };